// src/components/routes/RequireCreator.js
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useRole from "../../auth/useRole";
import { useAuth } from "../../auth/AuthContext";
import useStore from "../../store/useStore";
import { ACCOUNT_TYPES } from "../../services/profileService";

export default function RequireCreator() {
  const { isAdmin, isCreator } = useRole();
  const { user, loading } = useAuth() || {};
  const { userProfile } = useStore();
  const loc = useLocation();
  const hasAccountType = Object.values(ACCOUNT_TYPES).includes(userProfile?.accountType);

  if (loading) return null;
  if (!user) {
    return <Navigate to="/signin" state={{ from: loc }} replace />;
  }
  if (isAdmin) return <Outlet />;
  if (!hasAccountType) {
    return <Navigate to="/account-type" state={{ from: loc }} replace />;
  }
  if (isCreator) return <Outlet />;
  return <div style={{ padding: 24 }}>You don't have access to this section.</div>;
}
